// Address / place search via Photon (photon.komoot.io) — free, CORS-enabled,
// OSM-based, no API key. Results are biased to and filtered to greater Prague.
// If the service is unreachable the caller just shows "no results" — search is
// an optional convenience, never a hard dependency.

const PRAGUE = { lat: 50.087, lng: 14.421 }
const BBOX = { latMin: 49.9, latMax: 50.25, lngMin: 14.15, lngMax: 14.8 }

/**
 * @param {string} q
 * @param {{limit?: number, signal?: AbortSignal}} [opts]
 * @returns {Promise<Array<{lat:number, lng:number, name:string, detail:string}>>}
 */
export async function searchPlaces(q, { limit = 6, signal } = {}) {
  const url =
    `https://photon.komoot.io/api/?q=${encodeURIComponent(q)}` +
    `&limit=${limit}&lat=${PRAGUE.lat}&lon=${PRAGUE.lng}` +
    `&bbox=${BBOX.lngMin},${BBOX.latMin},${BBOX.lngMax},${BBOX.latMax}`
  const res = await fetch(url, { signal })
  if (!res.ok) throw new Error(`geocoder HTTP ${res.status}`)
  const data = await res.json()

  const seen = new Set()
  const out = []
  for (const f of data.features || []) {
    const [lng, lat] = f.geometry?.coordinates || []
    const p = f.properties || {}
    if (!(lat > BBOX.latMin && lat < BBOX.latMax && lng > BBOX.lngMin && lng < BBOX.lngMax)) continue
    const street = [p.street, p.housenumber].filter(Boolean).join(' ')
    const name = p.name || street
    if (!name) continue
    const detail = [street !== name ? street : null, p.district, p.city]
      .filter((x) => x && x !== name)
      .join(', ')
    const key = `${name}|${detail}`
    if (seen.has(key)) continue
    seen.add(key)
    out.push({ lat, lng, name, detail })
  }
  return out
}
